import { initialState, MyAccountState, OrderViewModel } from "@affinity/Store/MyAccountState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";


const reducer = {
    "MyAccount/Loading": (
        draft: Draft<MyAccountState>,
        action: {},
    ) => {
        draft.isLoading = true;
    },
    "MyAccount/Loaded": (
        draft: Draft<MyAccountState>,
        action: { openOrders: OrderViewModel[], totalOpenOrders: number, completedOrders: OrderViewModel[], totalCompletedOrders: number },
    ) => {
        draft.isLoading = false;
        draft.openOrders = action.openOrders;
        draft.totalOpenOrders = action.totalOpenOrders;
        draft.completedOrders = action.completedOrders;
        draft.totalCompletedOrders = action.totalCompletedOrders;
        draft.lastLoaded = new Date();
    }
}

export default createTypedReducerWithImmer(initialState, reducer);